// Auth-service endpoint paths (relative to VITE_AUTH_API_URL). Referenced via
// this constant so a path change is a single edit — never hard-coded at call
// sites. These are the UAE Pass single-entry surface: request an authorize URL,
// exchange the returned code, and complete sign-up for a new seller.
export const authEndpointPaths = {
  UAE_PASS_AUTHORIZE_URL: '/api/auth/uae-pass/authorize-url',
  UAE_PASS_CALLBACK: '/api/auth/uae-pass/callback',
  UAE_PASS_LOGOUT_URL: '/api/auth/uae-pass/logout-url',
  UAE_PASS_REGISTER: '/api/auth/uae-pass/register',
  LOGOUT: '/api/auth/logout',
} as const
